import FormattedMessageWithClass from './FormattedMessageWithClass';

export default FormattedMessageWithClass;
